import { FC, SVGProps } from "react";

const PlusThickIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentcolor"  {...props}>
      <rect x="6" y="0.5" width="2" height="13" rx="1" />
      <rect x="0.5" y="6" width="13" height="2" rx="1"/>
    </svg>
  );
};

export default PlusThickIcon;
